import { useState } from "react";

export const useSrcImage = () => {
  const [imageError, setImageError] = useState(false);

  const srcImage = (image: string) => {
    if (imageError || !image) {
      return "/inst/img/image-placeholder.svg";
    } else {
      return image;
    }
  };

  return {
    srcImage,
    setImageError,
    imageError
  };
};
